import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Login3 from './views/login3'
import Plants from './views/plants'
import Plants1 from './views/plants1'
import Contatcts from './views/contatcts'
import Penalty from './views/penalty'
import Dashboard from './views/dashboard'
import Monitoring from './views/monitoring'
import Cctv from './views/cctv'
import Reports from './views/reports'
import Inventory from './views/inventory'
import Settings from './views/settings'
import Manpower from './views/manpower'
import Collaboration from './views/collaboration'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Login3} exact path="/" />
        <Route component={Plants} exact path="/plants" />
        <Route component={Plants1} exact path="/plants1" />
        <Route component={Contatcts} exact path="/contatcts" />
        <Route component={Penalty} exact path="/penalty" />
        <Route component={Dashboard} exact path="/dashboard" />
        <Route component={Monitoring} exact path="/monitoring" />
        <Route component={Cctv} exact path="/cctv" />
        <Route component={Reports} exact path="/reports" />
        <Route component={Inventory} exact path="/inventory" />
        <Route component={Manpower} exact path="/manpower" />
        <Route component={Collaboration} exact path="/collaboration" />
        <Route component={Settings} exact path="/settings" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

const rootElement = document.getElementById('app')

if (rootElement) {
  ReactDOM.render(<App />, rootElement)
}
